module.exports = __webpack_public_path__ + "static/img/logo_010.3944eaeb.png";